var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.progress)?_c('v-layout',{staticStyle:{"height":"100vh"},attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":"80","indeterminate":_vm.progress,"color":"primary"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2295132","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/RedirectService.vue
// module id = null
// module chunks = 